import { useCallback } from 'react';

export function useIdemKey() {
  const generateKey = useCallback(async (action, payload) => {
    const str = `${action}:${JSON.stringify(payload)}:${Date.now()}`;
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return `disp:${payload.disputeId}:${action}:${hashHex.slice(0, 16)}`;
  }, []);

  return { generateKey };
}
